import {
  ProductControllerSearchSortByEnum,
  type ProductControllerSearchSortByEnum as ProductControllerSearchSortByEnumType,
} from "definitions/product-storage";

interface SortOption {
  id: number;
  type?: ProductControllerSearchSortByEnumType;
  title: string;
}

export const sortOptions: SortOption[] = [
  { id: 1, title: "По умолчанию" },
  {
    id: 2,
    type: ProductControllerSearchSortByEnum.Relevance,
    title: "Рекомендуемые",
  },
  {
    id: 3,
    type: ProductControllerSearchSortByEnum.Popularity,
    title: "Популярные",
  },
  {
    id: 4,
    type: ProductControllerSearchSortByEnum.PriceAsc,
    title: "По цене",
  },
  {
    id: 5,
    type: ProductControllerSearchSortByEnum.Newest,
    title: "Новые",
  },
  {
    id: 6,
    type: ProductControllerSearchSortByEnum.ReleaseDesc,
    title: "Сначала новые релизы",
  },
  {
    id: 7,
    type: ProductControllerSearchSortByEnum.ReleaseAsc,
    title: "Сначала старые релизы",
  },
];
